import React from 'react';
import Outdoor from '../../components/outdoor/index'
const OutdoorPage = () => {
    return (
        <div>
            <Outdoor />
        </div>

    )
}

export default OutdoorPage;